<template>
  <li>
    <span v-if="haveAvailableStage">
      <strong>{{ customerName }}</strong> peut participer aux cours
      <strong>{{ availableAgeRange }}</strong>,
      <span
        v-for="(level, levelIndex) in customer.available_levels"
        :key="`level-index-${levelIndex}`"
      >
        <span class="mr-1 ml-1" v-if="levelIndex > 0">ou</span>
        <b-icon
          class="mr-1"
          size="is-small"
          icon="circle"
          :style="`font-size: 0.8em; color: ${level.color_code}`"
        />
        <strong>{{ level.name }}</strong>
      </span>
    </span>

    <span
      v-else
      class="has-text-danger"
    >
      Nous n'avons pas de cours disponible pour l'âge et le niveau de <strong>{{ customerName }}</strong>
    </span>
  </li>
</template>

<script>
export default {
  name: "StageCustomersSummaryCustomerItem",

  props: {
    customer: {
      type: Object,
      required: true
    },
    plannedStages: {
      type: Array,
      required: true
    }
  },

  computed: {
    haveAvailableStage () {
      for (const stage of this.plannedStages) {
        if (
            this.customer.projected_age.age >= stage.min_age &&
            this.customer.projected_age.age <= stage.max_age &&
            this.customer.available_levels.map(level => { return level.id }).includes(stage.level.id)
        ) {
          return true;
        }
      }
      return false;
    },

    availableAgeRange () {
      const ageRange = [];
      const age = this.customer.projected_age.age;
      for (const plannedStage of this.plannedStages) {
        if (age < plannedStage.min_age || age > plannedStage.max_age) {
          continue;
        }

        let range = null;
        if (plannedStage.min_age >= 18) {
          range = `Adulte`;
        } else if (plannedStage.min_age === plannedStage.max_age) {
          range = `${plannedStage.min_age} ans`;
        } else {
          range = `${plannedStage.min_age}-${plannedStage.max_age} ans`;
        }
        if (!ageRange.includes(range)) {
          ageRange.push(range);
        }
      }
      return ageRange.join(', ');
    },

    customerName () {
      if (this.customer.age >= 18) {
        return `${this.customer.firstname} ${this.customer.lastname}`;
      } else {
        return this.customer.firstname;
      }
    }
  }
}
</script>
